<!-- 试题内容 -->
<template>
  <div class="stems" ref="dialog" title="操作日志"
    :close-on-click-modal="false">
    <div class="longContainer">
      <div class="logDate">
        类型：
        <el-select v-model="categoryType" style="margin-right: 20rem;">
            <el-option value="0" label="听说图书"></el-option>
            <el-option value="1" label="听说精练"></el-option>
        </el-select>
        时间：
        <el-date-picker v-model="dateRage" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button class="preserveHandle" type="primary" @click="search">搜索</el-button>
        <el-button class="preserveHandle" type="primary cancel" @click="reset">重置</el-button>
      </div>

      <div class="logs">
        <el-table :data="logData" height="540" stripe style="width: 100%">
          <el-table-column prop="id" label="编号" width="160" align="center">
          </el-table-column>
          <el-table-column prop="createTime" label="操作时间" width="300" align="center">
          </el-table-column>
          <el-table-column prop="nickName" label="操作人" width="220" align="center">
          </el-table-column>
          <el-table-column prop="operation" label="操作类型" width="320" align="center">
          </el-table-column>
          <el-table-column prop="description" label="操作描述" class-name="info">
          </el-table-column>
        </el-table>
      </div>
      <div class="logBottom">
        <div class="logNum">
          第 {{ startNum }}-{{ endNum }} 条 / 总共 {{ totalNum }} 条
        </div>
        <div class="logPage">
          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :current-page="curPage" @current-change="gotoPage"
              :page-count="pageCount">
            </el-pagination>
          </div>
          <div class="jumpPage">前往 <el-input-number class="scoreClass" :controls="false" type="number"
              @change="jumpToPage" v-model="jumpPage" size="mini" :min="1"></el-input-number> 页</div>
          <div class="pageSize">
            <el-select v-model="pageSize" @change="changePageSize" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { getLogs } from '@/api/user';
import _ from 'lodash';
import moment from "moment";
export default {
  name: "OperationLog",

  props: {
  },

  components: {
  },

  data() {
    return {
      logData: [],
      pageSize: 10,
      curPage: 1,
      jumpPage: 1,
      totalNum: 666,
      dateRage: '',
      logVisibleControl: false,

      options: [
        {
          value: 10,
          label: '10条/页'
        },
        {
          value: 20,
          label: '20条/页'
        }, {
          value: 50,
          label: '50条/页'
        }, {
          value: 100,
          label: '100条/页'
        }
      ],
      categoryType:''
    };
  },

  methods: {
    changeDate() {
      this.getLogData()
    },
    gotoPage(val) {
      this.curPage = val;
      this.getLogData()
    },
    jumpToPage(val) {
      this.curPage = val;
    },
    changePageSize(val) {
      if (this.curPage * val > this.totalNum) {
        this.curPage = Math.ceil(this.totalNum / val)
      }
      this.getLogData()
    },
    search() {
      this.getLogData()
    },
    reset() {
      this.dateRage = '';
      this.categoryType = '';
      this.initDate();
      this.getLogData();
      this.$message.success('重置成功')
    },
    getLogData() {
      console.log(this.dateRage);
      let startDate = '', endDate = '';
      if (this.dateRage) {
        startDate = moment(_.get(this.dateRage, '0')).format('YYYY-MM-DD');
        endDate = moment(_.get(this.dateRage, '1')).format('YYYY-MM-DD');
      }
      //TODO
      const data = {
        "pageNum": this.curPage,
        "pageSize": this.pageSize,
        startDate,
        endDate,
        'type':this.categoryType==''?-1:this.categoryType
      }
      getLogs(data).then(res => {
        if (res.code == 0) {
          this.logData = _.get(res, 'list', []);
          this.totalNum = _.get(res, 'total', 0);
        }
        console.log(res)
      }).catch(e => {
        console.log(e)
      })
      // for (let i = 1; i <= this.pageSize; i++) {
      //   this.logData.push({
      //     num: i,
      //     date: moment().format("YYYY-MM-DD  HH:mm:SS"),
      //     name: "叶某某",
      //     type: "瞎搞瞎搞",
      //     info: "把系统搞崩了把系统搞崩了把系统搞崩了把系统搞崩了把系统搞崩了"
      //   })
      // }
      console.log(this.logData)
    },
    initDate(){
      let oneDay = 24 * 60 * 60 * 1000
      let startData = new Date(Date.now() - 7*oneDay)
      let endData = new Date();
      this.dateRage = [startData,endData]
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalNum / this.pageSize)
    },
    startNum() {
      return (this.curPage - 1) * this.pageSize + 1;
    },
    endNum() {
      return this.curPage * this.pageSize;
    }
  },
  watch: {
    centerDialogVisibleCopy() {
    },
  },

  mounted() {
    this.initDate();
    this.getLogData()
  },
  beforeDestroy() {
  },
};
</script>

<style lang="scss" scoped>
.stems {
    width: 100%;
    height: 100vh;
    background: #fff;
    border-radius: 12rem;
    box-sizing: border-box;
    padding: 0rem 20rem 20rem;
    position: relative;
}
.longContainer {
  background: #fff;
  border-radius: 8rem;
  padding: 20rem;
  box-sizing: content-box;
  margin-bottom: 20rem;
  width: calc(100% - 50rem);
}

.logDate {
  width: 100%;
  height: auto;
  margin-bottom: 20rem;

  ::v-deep .el-range-editor.el-input__inner {
    padding: 0 10rem;
  }

 ::v-deep.el-date-editor--daterange {
    width: 320rem
  }

  .preserveHandle {
    width: 76rem;
    height: 32rem;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);
    margin-left: 18rem;

    &.cancel {
      background: none;
      color: var(--primary-color);
      border-color: var(--primary-color);
    }

    &.cancel:hover {
      background-image: none;
      border-color: var(--primary-color);
    }
  }

  .preserveHandle:hover {
    width: 76rem;
    height: 32rem;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);
  }
}

.logs {
  border: 1rem solid #EBEEF5;

 ::v-deep.info {
    padding-left: 20rem;
  }

 ::v-deep.el-table thead {
    color: #303133;
    font-size: 14rem;
  }

 ::v-deep.el-table {
    color: #4D4F53;
  }

 ::v-deep.el-table__body-wrapper::-webkit-scrollbar {
    width: 6rem;
    height: 16rem;
  }

 ::v-deep.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3rem;
  }
}

.logBottom {
  height: 60rem;
  display: flex;
  color: #333333;
  font-size: 12rem;
  align-items: center;
  justify-content: space-between;

  .logPage {
    display: flex;
    justify-content: space-around;

   ::v-deep.el-pagination.is-background .el-pager li {
      color: #4D4F53;
    }

   ::v-deep.el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: var(--primary-color);
    }

   ::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #fff;
    }

    .jumpPage {
      margin: 0 8rem;
      display: flex;
      white-space: nowrap;
      width: 90rem;
      align-items: center;

      .scoreClass {
        margin: 0 4rem;
        ::v-deep .el-input--mini .el-input__inner{
          padding: 0!important;
        }
      }

     ::v-deep.el-input__inner {
        height: 25rem;
        line-height: 25rem;
        padding: 0 5rem;
        text-align: center;
      }
    }

    .pageSize {
      width: 110rem;
      display: flex;
      align-items: center;

     ::v-deep.el-input__inner {
        height: 25rem;
        line-height: 25rem;
        padding: 0 5rem;
        text-align: center;
      }

     ::v-deep.el-input__icon {
        line-height: 25rem;
      }
    }
  }

 ::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: var(--primary-color)
  }
}

.coilingTable {
  height: 200rem;
  width: 100%;
  // overflow-x: scroll;
  border: 1rem solid #e9e9e9;
  padding-top: 15rem;
  min-width: 600rem;
}

.coilingBox {
  display: flex;
  flex-direction: row;
  // position: relative;
  padding-right: 20rem;
}

.coilingChildList {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .coilingChild:only-child {
    width: 100%;

    .coilingInput {
      width: calc(100% - 10rem) !important;
    }
  }
}

.coilingChild {
  text-align: center;
  box-sizing: border-box;

}

.coilingChild2 {
  min-width: 50rem;
}

.coilingChild3 {
  width: 50rem;
  // background: #ccc;
  // margin: 1rem;
}

.coilingInside {
  height: 32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  >div {
    width: 100%;
    height: 100%;
    background: #d5fae0;
    border-radius: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16rem;
    color: #303133;
    padding: 5rem;
    box-sizing: border-box;
    // font-weight: 600;

    span {
      font-size: 10rem;
      color: #303133;
      font-weight: 400;
    }
  }

  padding: 5rem;
}

.testContentBox {
  :deep .el-icon-star-on {
    color: #fcca00;
  }

  .tooltipIcon {
    cursor: pointer;
    font-size: 14rem;
    font-weight: 600;
    display: flex;
    align-items: center;

    img {
      margin-right: 2rem;
      width: 16rem;
      height: 16rem;
    }
  }
}

.elIconStar {
  font-size: 12rem;

  p {
    color: #ffb802;
    display: inline-block;
    cursor: pointer;

    img {
      width: 6rem;
      height: 11rem;
      position: relative;
      top: 1rem;
    }
  }
}

.enable {
  font-size: 14rem;
  color: #303133;
  margin: 0 16rem 0 20rem;
}

.btnAddressF {
  color: #fff;
}

.btnAddressPlain {
  background-image: none !important;
  color: #0bae6a;
  border-radius: 6rem;
  border-color: #0bae6a;
}

.btnAddressPlain:hover {
  color: #0bae6a;
}

:deep .el-dropdown-menu__item:hover {
  background: #d5fae0;
  color: #0bae6a;
}

.stems {

  ::v-deep .el-dialog {
    border-radius: 10rem;
    height: auto !important;
    background: #f5f5f5;
  }

  :deep .el-tabs__item {
    padding: 6rem 16rem !important;
    height: auto;
    line-height: normal;
    color: #303133;
    background: #ecdcdc;
    border-radius: 6rem;
    margin-right: 10rem;
  }

  :deep .el-tabs__item.is-active {
    color: #fff;
    background: linear-gradient(to right, #09b17e, #08c162);
  }

  ::v-deep .el-dialog__title {
    padding-left: 26rem;

    &:before {
      content: "";
      position: absolute;
      left: 30rem;
      top: 22rem;
      width: 5rem;
      height: 20rem;
      border-radius: 10rem;
      background-color: var(--primary-color);
    }
  }

  .coilingTable {
    background: #fff;
    border-radius: 8rem;
    height: 320rem !important;
    // display: flex;
    // flex-direction: row;
    padding-top: 15rem !important;
    box-sizing: border-box;

    .promptGive {
      width: 112rem;
      // height: 310rem;
      padding-top: 132rem;

      >p {
        text-align: center;
        font-size: 12rem;
        color: #000;
        margin-bottom: 17rem;
      }
    }
  }

  .coilingInput {
    padding: 5rem;

    :deep .el-input__inner {
      padding: 0 3rem;
      text-align: center;
    }
  }

  .coilingBrief {
    position: absolute;
    top: 230rem;
    left: 317rem;
    height: 40rem;
    min-width: 300rem;
    background: #f6f6f6;
    border-radius: 8rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 3rem 0 5rem;

    >p {
      font-size: 14rem;
      color: #a8abb2;
      padding: 0 10rem;

      span {
        color: #303133;
      }
    }
  }

  :deep .__panel,
  :deep .__view {
    position: initial !important;
  }
}

.preserveHandleBox {
  display: flex;
  justify-content: end;
  padding: 16rem 0 22rem;

  .preserveHandle {
    width: 76rem;
    height: 32rem;
    padding: 0;
  }

  .preserveHandle:hover {
    width: 76rem;
    height: 32rem;
    padding: 0;
    background-image: var(--background-image);
    border-color: var(--primary-color);
  }
}

.coilingLabelOne {
  width: 80rem;
}

.cfDialog {
  ::v-deep .el-dialog {
    border-radius: 10rem;
    height: auto !important;

    .el-dialog__body {
      padding: 13rem 20rem;
    }
  }

  .dialog-header {
    margin-left: 10rem;
    font-size: 18rem;
    font-weight: 700;
  }

  .dialog-content {
    margin-left: 43rem;
  }

  .dialog-header::before {
    content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAApdJREFUSEvNlk1IVFEUx3/PpjJTKtJKkxIyGdMYpBYTqCUaWLoY0T6gbVC7WhS1mKiwRZFQy1q0qkVCkvZlC8XEj4LaDI44i4pgJrBsIVg6pHnjds15b+Z9RWN0V+/dc+7/d8+559z3NCGE4B8O7f8Gzs/BSBDe3VY5KTkFO4KQ4XGdoz+L8M3JBOw3QkIrbi4B8PML6KsxF657Cev9rqDuIvwRhx4/TIbMRdftgrremrlLrDhhpg9DZBGxNOcjznIok5ipuQMlremyidgdMxeLod5uNKLL8Bqp+o56EWiHWo5+VroX4Esgptoc7A4aMQbU+I+K6D94x6T4586zHw3/sL4HgP9O83CnjPge+qmgudh8g1o72mDzbss4RaRygL5flO+PrWuHjbCdh9S829Pg7v7xjtOV6VWovetAaOXoHwhdSdbg5A5cPUM9R76tOepGAO/PYBnpUmCkW/KLcSagfUTG8VfBlM3ZQnGw6MmRaQOXAwAB+7zM9BtoRMmRxyU/rW0K/YcgT23E/RSAXGOmGoybrSVuRC04Syd+VDfNzat7ob8usNdiNQFkp3KciUWg3NA4dnlbVds/aTluxilY1lmYt+RmD4EoxetheR1sBChJ15zr7lrVAWNAHaFUqyrCwIOWQ2nEZGpooyp/iXZyJCu0JJFs3bq2Ym+p1wyq67DhUw+gCGD7lbLL1WblItMzvpfk3VYyhoRBNzM8KxUPSyG2uhauHyHmiET73uoFlFcHAMTYRbhemNYiVjd3k7ocsuoolHRYJpmzZIFpGl7r8LshjkMSTftXbQ1UVoot0jEHNOe0uremfOgicFmsfgRTY+stUphM5r4PiUIByHaATOxpUGuKoSCBvC16fpwaVApqs6/GGneyE++5g+RAjOCZQAAAABJRU5ErkJggg==);
    position: relative;
    top: 5rem;
    left: -13rem;
  }
}

.dialog-footer {}
</style>